// extracted by mini-css-extract-plugin
module.exports = {"container":"AvatarEditable__container__-Jl8A"};